import React from 'react';
import { Button } from './Button';
export function FinalCTA() {
  return <section className="py-10 md:py-16 px-4 sm:px-6 lg:px-8 text-center bg-zinc-950" data-id="element-41">
      <h3 className="text-2xl md:text-4xl font-bold text-white mb-6 md:mb-8" data-id="element-42">
        Hacé clic y empezá hoy.
      </h3>
      <Button href="#comprar" className="text-lg md:text-2xl py-4 md:py-5 px-8 md:px-12" data-id="element-43">
        Acceder ahora
      </Button>
    </section>;
}